import { render, staticRenderFns } from "./PHorizontalCardList.vue?vue&type=template&id=54e33a86&"
import script from "./PHorizontalCardList.vue?vue&type=script&lang=ts&"
export * from "./PHorizontalCardList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports